import { useCallback } from "react";

import useI2FLink from "./useI2FLink";
import useProfile from "../useProfile";
import { isIndividualUser, isLinked } from "../../../utills";

// Opens the Classic i2File application (links the profile first if needed)
const useOpenClassicI2File = () => {
  const profile = useProfile();
  const i2fLink = useI2FLink();

  const openClassicI2File = useCallback(async () => {
    if (profile.data) {
      i2fLink.mutateAsync({
        liteUser: profile.data.email,
        defaultToSupremeCourtCounty: false,
        isUserProfileLinked: isLinked(),
        liteUserFirstName: profile.data.firstName,
        liteUserLastName: profile.data.lastName,
        liteUserRole: isIndividualUser() ? "prose" : "Attorney",
      });
    }
  }, [profile.data, i2fLink]);

  // Classic i2File Document Request page; falls back to the normal Classic i2File redirect
  const openClassicDocumentRequest = useCallback(() => {
    const url = process.env.REACT_APP_CLASSIC_I2FILE_DOCUMENT_REQUEST_URL;
    if (url) {
      window.location.href = url.trim();
    } else {
      openClassicI2File();
    }
  }, [openClassicI2File]);

  return {
    openClassicI2File,
    openClassicDocumentRequest,
    isLoading: i2fLink.isLoading,
  };
};

export default useOpenClassicI2File;
